/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { cva, VariantProps } from 'class-variance-authority'
import NextImage, { ImageProps as NextImageProps } from 'next/image'
import React from 'react'

import { cn } from '@/utils/css'

/** Variants for the image component. */
const imageVariants = cva('', {
  variants: {
    rounded: {
      none: 'rounded-none',
      sm: 'rounded-xs',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      '3xl': 'rounded-3xl',
      full: 'rounded-full',
    },
    shadow: {
      none: '',
      sm: 'shadow-xs',
      md: 'shadow-md',
      lg: 'shadow-lg',
    },
  },
  defaultVariants: {
    rounded: 'none',
    shadow: 'none',
  },
})

/** A description of available properties for this component. */
type ImageProps = Omit<NextImageProps, 'alt'> &
  VariantProps<typeof imageVariants> & {
    alt: string
  }

/**
 * A customisable image component that wraps the Next.js Image component with additional features.
 */
const Image: React.FC<ImageProps> = ({ className, rounded, shadow, alt, ...props }) => {
  return <NextImage className={cn(imageVariants({ rounded, shadow, className }))} alt={alt} {...props} />
}

export { Image }
